<template>
    <ot-section v-bind="$attrs" :theme="$otTheme" section>
        <ot-row-group :theme="$otTheme" :code="code">
            <ot-button @click="openRound()">圆角</ot-button>
            <ot-button @click="openBorder()">边框</ot-button>
            <ot-button @click="open()">圆角带边框</ot-button>
        </ot-row-group>
    </ot-section>
</template>

<script>
export default {
    data() {
        return {
            code: decodeURIComponent(`%3Ctemplate%3E%0A%20%20%20%20%3Cot-section%20section%3E%0A%20%20%20%20%20%20%20%20%3Cot-row-group%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-button%20%40click%3D%22openRound()%22%3E%E5%9C%86%E8%A7%92%3C%2Fot-button%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-button%20%40click%3D%22openBorder()%22%3E%E8%BE%B9%E6%A1%86%3C%2Fot-button%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-button%20%40click%3D%22open()%22%3E%E5%9C%86%E8%A7%92%E5%B8%A6%E8%BE%B9%E6%A1%86%3C%2Fot-button%3E%0A%20%20%20%20%20%20%20%20%3C%2Fot-row-group%3E%0A%20%20%20%20%3C%2Fot-section%3E%0A%3C%2Ftemplate%3E%0A%0A%3Cscript%3E%0Aexport%20default%20%7B%0A%20%20%20%20data()%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%2C%0A%20%20%20%20methods%3A%20%7B%0A%20%20%20%20%20%20%20%20openRound()%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20this.%24otMessage(%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20title%3A%20'%E8%BF%99%E6%98%AF%E4%B8%80%E6%9D%A1%E6%B6%88%E6%81%AF%E6%8F%90%E7%A4%BA'%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20round%3A%20true%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20theme%3A%20this.%24otTheme%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%7D)%3B%0A%20%20%20%20%20%20%20%20%7D%2C%0A%20%20%20%20%20%20%20%20openBorder()%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20this.%24otMessage(%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20title%3A%20'%E8%BF%99%E6%98%AF%E4%B8%80%E6%9D%A1%E6%B6%88%E6%81%AF%E6%8F%90%E7%A4%BA'%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20border%3A%20true%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20theme%3A%20this.%24otTheme%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%7D)%3B%0A%20%20%20%20%20%20%20%20%7D%2C%0A%20%20%20%20%20%20%20%20open()%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20this.%24otMessage(%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20title%3A%20'%E8%BF%99%E6%98%AF%E4%B8%80%E6%9D%A1%E6%B6%88%E6%81%AF%E6%8F%90%E7%A4%BA'%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20round%3A%20true%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20border%3A%20true%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20theme%3A%20this.%24otTheme%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%7D)%3B%0A%20%20%20%20%20%20%20%20%7D%2C%0A%20%20%20%20%7D%2C%0A%7D%3B%0A%3C%2Fscript%3E`),
        };
    },
    methods: {
        openRound() {
            this.$otMessage({
                title: '这是一条消息提示',
                round: true,
                theme: this.$otTheme,
            });
        },
        openBorder() {
            this.$otMessage({
                title: '这是一条消息提示',
                border: true,
                theme: this.$otTheme,
            });
        },
        open() {
            this.$otMessage({
                title: '这是一条消息提示',
                round: true,
                border: true,
                theme: this.$otTheme,
            });
        },
    },
};
</script>
